export default "__VITE_ASSET__BN7HXvuX__"